
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Adventureresortinnagpurdistrictwithtigersafari() {



  const cardData =
  {
    keyword: ' Adventure Resort in Nagpur District with Tiger Safari',
    heading:  'Woodland Escape: Adventure Resort in Nagpur District with Tiger Safari ',
    headingDescription: 'Woodland Escape Resort offers a thrilling and immersive adventure resort experience in Nagpur District with tiger safari access, nestled amid lush forest settings where nature and excitement meet. Featuring sprawling lawns, tree-lined trails, and open grounds that give way to nearby tiger reserve pathways, the resort provides an ideal launch point for safari-style excursions and adventure activities. Guests can partake in guided forest walks, early-morning safari drives, and outdoor adventure games before retreating to luxurious cottages for comfort and relaxation. With dedicated event and hospitality staff, in-house catering, and nature-friendly décor, Woodland Escape Resort blends bold adventure with resort-style comfort — making it a standout choice for travellers seeking both the wild and the refined in Nagpur District.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Adventure Resort in Nagpur District with Tiger Safari",
      "description": "Experience the thrill of adventure and wildlife in Nagpur district with resorts offering guided tiger safaris, jungle treks, and immersive nature activities. Perfect for wildlife enthusiasts, families, and adventure seekers looking for an unforgettable stay amidst the wild."
    },
    {
      "name": "Nagpur Tiger Safari Resort",
      "description": "Stay close to the jungle at Nagpur Tiger Safari Resorts, with direct access to safari tours, expert-guided wildlife experiences, and luxurious accommodations. Witness majestic tigers and other wildlife in their natural habitat while enjoying top-notch facilities."
    },
    {
      "name": "Nagpur Wildlife Adventure Resort",
      "description": "Combine adventure and wildlife at Nagpur resorts offering jungle excursions, bird watching, and outdoor activities. Enjoy nature walks, photography opportunities, and comfortable stays surrounded by the rich biodiversity of the region."
    },
    {
      "name": "Nagpur Jungle Safari Resort",
      "description": "Immerse yourself in the jungle at Nagpur safari resorts featuring guided tours, treks, and interactive wildlife experiences. Perfect for families, couples, or solo travelers seeking adventure and nature in one package."
    },
    {
      "name": "Nagpur Tiger Viewing Resort",
      "description": "Get the best tiger viewing experience at Nagpur resorts with expert guides, safaris, and strategic viewing points. Relax in luxury accommodations after a day of thrilling wildlife encounters."
    },
    {
      "name": "Nagpur Nature Adventure Resort",
      "description": "Explore the wilderness at Nagpur resorts offering adventure activities like trekking, river rafting, and nature trails. Stay amidst lush greenery and enjoy a mix of excitement and relaxation."
    },
    {
      "name": "Nagpur Outdoor Activity Resort",
      "description": "Enjoy outdoor adventures at Nagpur resorts including zip-lining, camping, bonfires, and jungle trails. Perfect for families, friends, and groups looking for a fun-filled nature escape."
    },
    {
      "name": "Nagpur Eco Adventure Resort",
      "description": "Stay in eco-friendly adventure resorts in Nagpur, designed to minimize environmental impact while providing thrilling wildlife and nature activities. Ideal for sustainable travelers who love nature and adventure."
    },
    {
      "name": "Nagpur Wildlife Luxury Resort",
      "description": "Experience luxury amidst the wild at Nagpur resorts, combining high-end accommodations with exclusive wildlife safaris. Perfect for travelers seeking comfort without missing out on adventure."
    },
    {
      "name": "Nagpur Adventure Stay with Safari",
      "description": "Book an adventure stay at Nagpur resorts that include guided safari tours, nature treks, and wildlife spotting. Ideal for families and groups wanting both relaxation and adventure in one destination."
    },
    {
      "name": "Nagpur Jungle Adventure Resort",
      "description": "Dive into the jungle adventure at Nagpur resorts with camping, bonfires, trekking, and wildlife exploration. Enjoy immersive experiences in the heart of nature with comfortable accommodations."
    },
    {
      "name": "Nagpur Family Adventure Resort",
      "description": "Perfect for families, these Nagpur resorts combine wildlife safaris with family-friendly adventure activities, playgrounds, and safe outdoor experiences, ensuring fun and safety for all ages."
    },
    {
      "name": "Nagpur Adventure Booking",
      "description": "Easily book adventure resorts in Nagpur with options for safari tours, outdoor activities, and guided jungle experiences. Hassle-free planning for a thrilling and memorable stay."
    },
    {
      "name": "Nagpur Safari Tour Resort",
      "description": "Stay at resorts offering comprehensive safari tours in Nagpur, with expert guides, wildlife photography sessions, and comfortable lodging. Perfect for wildlife enthusiasts and adventure seekers."
    },
    {
      "name": "Nagpur Adventure Activities Resort",
      "description": "Enjoy a variety of adventure activities at Nagpur resorts, including trekking, zip-lining, bird-watching, and jungle exploration. Ideal for groups, families, and solo travelers looking for action-packed nature experiences."
    }
  ],
  "tableData": [
    ["- Adventure Resort in Nagpur District with Tiger Safari", "- Nagpur Tiger Safari Resort"],
    ["- Nagpur Wildlife Adventure Resort", "- Nagpur Jungle Safari Resort"],
    ["- Nagpur Tiger Viewing Resort", "- Nagpur Nature Adventure Resort"],
    ["- Nagpur Outdoor Activity Resort", "- Nagpur Eco Adventure Resort"],
    ["- Nagpur Wildlife Luxury Resort", "- Nagpur Adventure Stay with Safari"],
    ["- Nagpur Jungle Adventure Resort", "- Nagpur Family Adventure Resort"],
    ["- Nagpur Adventure Booking", "- Nagpur Safari Tour Resort"],
    ["- Nagpur Adventure Activities Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Adventure & Forest Experience in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort offers an exciting adventure experience in Nagpur district with lush forest surroundings. Guests can enjoy nature trails, outdoor activities, and the thrill of wildlife‑oriented excursions, all while staying in comfortable, scenic accommodations."
  },
  {
    "WhyChooseheading": "Rooms with Stunning Forest Views",
    "WhyChoosedescription": "Each room at Woodland Escape Resort is designed to offer panoramic views of the surrounding forest. Wake up to the sounds of nature, sunlight filtering through dense trees, and the calm of a forested landscape — making your stay both adventurous and serene."
  },
  {
    "WhyChooseheading": "Thrilling Tiger‑Safari Style Excursions",
    "WhyChoosedescription": "While located near wildlife zones, the resort provides guided wildlife excursions and jeep trails mimicking a tiger safari experience. Guests can spot birds, deer, and other forest inhabitants, making it ideal for wildlife enthusiasts and families seeking adventure."
  },
  {
    "WhyChooseheading": "Outdoor & Adventure Activities",
    "WhyChoosedescription": "Woodland Escape Resort offers numerous outdoor activities including nature walks, cycling, zip‑lining, and obstacle courses. These activities are designed for all age groups, combining adventure, recreation, and learning about forest ecosystems."
  },
  {
    "WhyChooseheading": "Ideal for Family & Group Adventures",
    "WhyChoosedescription": "The resort is perfect for families, friends, and adventure groups. Its expansive grounds allow for safe play, group activities, and team challenges, ensuring both bonding and excitement amidst natural surroundings."
  },
  {
    "WhyChooseheading": "Comfortable & Nature‑Friendly Facilities",
    "WhyChoosedescription": "From shaded sit‑outs to well-equipped rooms, Woodland Escape Resort ensures guests enjoy comfort without losing the forest experience. Facilities are thoughtfully designed to blend with nature while providing all modern amenities."
  },
  {
    "WhyChooseheading": "Easily Accessible from Nagpur",
    "WhyChoosedescription": "Located within convenient reach of Nagpur city, Woodland Escape Resort provides a quick escape into nature. Guests can enjoy a full adventure experience without long travel times, making it ideal for weekend trips or short getaways."
  }
]


























  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as an adventure resort in Nagpur district with tiger safari?",
    answer: "Woodland Escape Resort offers an exhilarating adventure‑stay in Nagpur district, paired with access to tiger safari excursions. It blends comfort, thrill and nature for guests looking for an immersive wildlife experience."
  },
  {
    question: "How far is Woodland Escape Resort from the nearest tiger safari zone in Nagpur district?",
    answer: "The resort is conveniently located within driving distance of one of Nagpur district’s tiger safari parks, making it accessible for morning and evening safari drives while staying comfortably on‑site."
  },
  {
    question: "What adventure facilities does Woodland Escape Resort offer alongside tiger safari?",
    answer: "The resort provides guided jungle safaris or partner access to safari zones, nature trails, outdoor games, open lawns and adventure activities such as trekking or cycling—all set in a lush natural backdrop."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups seeking both adventure and safari?",
    answer: "Yes! The resort is family‑friendly and group‑friendly. It offers safe outdoor zones, supervised adventure‑activities, and access to tiger safari drives that bring both excitement and comfort to all ages."
  },
  {
    question: "Does the resort provide safari booking support, meals and services for adventure guests?",
    answer: "Absolutely. Woodland Escape Resort assists with tiger safari bookings, provides freshly prepared meals, snacks and beverages, and offers services that support a full adventure‑stay experience in nature."
  },
  {
    question: "How can we book Woodland Escape Resort for an adventure‑stay with tiger safari in Nagpur district?",
    answer: "You can make your booking by calling or messaging the resort’s reservation team via WhatsApp, or via their official website. Advance booking is recommended, particularly for safari slots and weekends."
  }
];

const testimonials = [
  {
    name: "Mr. Sameer & Friends, Nagpur",
    text: "Our adventure stay at Woodland Escape Resort was spectacular! The guided safari was thrilling, the surroundings were wild yet safe, and the resort amenities were top‑notch. A great tiger safari adventure in Nagpur district."
  },
  {
    name: "Ms. Ayesha & Family, Nagpur",
    text: "We chose Woodland Escape Resort for our family adventure + safari trip. The kids loved the jungle trails and spotting wildlife on safari, while the adults enjoyed the comfort and scenery. Highly recommended!"
  }
];































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Adventure Resort in Nagpur District with Tiger Safari",
  "image": "https://woodlandescape.com/assets/images/nagpur-tiger-safari-resort.jpg",
  "description": "Experience thrilling wildlife adventures at our Nagpur Tiger Safari Resort. Enjoy tiger sightings, jungle safaris, outdoor activities, and luxury stays surrounded by nature.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "38"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7499",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nagpur-tiger-safari-resort"
  }
};



  return (
    <div>
<Helmet>
  <title>Adventure Resort in Nagpur District with Tiger Safari | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Discover adventure and wildlife at Nagpur Tiger Safari Resort. Enjoy tiger safaris, jungle adventures, outdoor activities, eco-friendly luxury stays, and family adventure vacations." 
  />
  <meta 
    name="keywords" 
    content="Adventure Resort in Nagpur District with Tiger Safari, Nagpur Tiger Safari Resort, Nagpur Wildlife Adventure Resort, Nagpur Jungle Safari Resort, Nagpur Tiger Viewing Resort, Nagpur Nature Adventure Resort, Nagpur Outdoor Activity Resort, Nagpur Eco Adventure Resort, Nagpur Wildlife Luxury Resort, Nagpur Adventure Stay with Safari, Nagpur Jungle Adventure Resort, Nagpur Family Adventure Resort, Nagpur Adventure Booking, Nagpur Safari Tour Resort, Nagpur Adventure Activities Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/49.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Adventureresortinnagpurdistrictwithtigersafari;